import { render, staticRenderFns } from "./AdmissionDemissionDate.vue?vue&type=template&id=4c4d6773"
import script from "./AdmissionDemissionDate.vue?vue&type=script&lang=ts"
export * from "./AdmissionDemissionDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports